import type { AuthPageShellProps } from './AuthPageShell';

/**
 * The brand panel beside everything about verifying an email: the
 * `/verify-email` page, and the gate an unverified account meets in place of
 * the app.
 */
export const EMAIL_VERIFICATION_BRAND: Pick<
  AuthPageShellProps,
  'headline' | 'lede' | 'kanji'
> = {
  headline: 'Step through the gate.',
  lede: 'One link from your inbox shows the address is yours. Then the whole practice opens up.',
  kanji: '門',
};
